module.exports = function() {
  return new Worker(__webpack_public_path__ + "9f6e8095955f554d3d68.worker.js");
};